import HTTPClient, { HTTPClientParameters } from './HTTPClient';

type OperationsRegionClientParams = HTTPClientParameters;

type SpotsOperationsRegion = {
    contact_number: string;
    region: string;
};

class OperationsRegionClient extends HTTPClient {
    constructor(params: OperationsRegionClientParams) {
        super(params);
        this.headers.set('Content-Type', 'application/json');
    }

    getOrganizationOperationsRegion(org: number): Promise<SpotsOperationsRegion> {
        return this.get(`operations_region/organizations/?org=${org}`);
    }
}

export default OperationsRegionClient;
